import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { TodayOfferCard } from './TodayOfferCard';
import { CHECKOUT_URL } from '../data/content';
const rows: [string, string][] = [['Vol 1 — Elements of Art™', '$27 Value'], ['Vol 2 — Drawing & Illustration™', '$27 Value'], ['Vol 3 — Color, Painting & Mixed Media™', '$27 Value'], ['Vol 4 — Principles of Design™', '$27 Value'], ['Vol 5 — Art, Artists & Visual Cultures™', '$27 Value'], ['Vol 6 — Art Projects & Creative Challenges™', '$27 Value'], ['Bonus 1 — Art Assessment Made Simple™', '$47 Value'], ['Bonus 2 — The Art Teacher Planner™', '$47 Value'], ['Bonus 3 — 10-Minute Art Rescue™', '$27 Value'], ['Bonus 4 — Art Classroom Visuals™', '$37 Value'], ['Bonus 5 — Student Art Portfolio™', '$27 Value']];
export function ValueStack() {
  return <section id="offer" className="w-full scroll-mt-20 bg-navy-mid px-5 py-12 sm:py-20" data-id="element-225" data-mp="30wk0t0jthn6r">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto max-w-[600px]" data-id="element-226" data-mp="35r7urexlb9sq">
        <h2 className="text-center font-display text-2xl font-bold text-white sm:text-4xl" data-id="element-227" data-mp="235y4db5tdsr8">
          Everything You Need to Support the Art Year—in One Connected System.
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-sm text-white/70 sm:text-base" data-id="element-228" data-mp="2c530ybxtfc0r">
          The six core volumes give you the teaching content. The five professional bonuses help with
          the planning, assessment, quick classroom needs, visual support and student progress that
          happen around it.
        </p>
        <div className="mt-6 rounded-2xl border border-gold/45 bg-navy p-4 sm:mt-8 sm:p-6" data-id="element-229" data-mp="2h5qqsuab5mte">
          <ul data-id="element-230" data-mp="rqj6m55s6wv2">
            {rows.map(([label, price]) => <li key={label} className="flex items-center justify-between gap-3 border-b border-dashed border-gold/30 py-2 last:border-b-0 sm:py-2.5" data-id="element-231" data-mp="mrg52up0f8ru">
                <span className="text-[13px] text-white/85 sm:text-sm" data-id="element-232" data-mp="2rrqxr25gl8lq">{label}</span>
                <span className="shrink-0 text-[13px] font-medium text-white/65 sm:text-sm" data-id="element-233" data-mp="2vu3y1b1fseb4">
                  {price}
                </span>
              </li>)}
          </ul>
          <div className="my-4 h-px w-full bg-gold/45" data-id="element-234" data-mp="35s1lhwbh272o" />
          <div className="flex items-center justify-between" data-id="element-235" data-mp="35rifndz3j950">
            <span className="text-[13px] text-white/65 sm:text-sm" data-id="element-236" data-mp="3aql87yxw3mw3">Combined value</span>
            <span className="text-lg font-medium text-white/55 line-through sm:text-xl" data-id="element-237" data-mp="3fi3d2y31a7mc">
              $347 USD
            </span>
          </div>
          <div className="mt-4 flex flex-col items-center rounded-xl border border-gold/30 bg-navy-mid py-5 text-center sm:py-6" data-id="element-238" data-mp="3jix0lqckdkep">
            <span className="text-sm font-medium text-gold" data-id="element-239" data-mp="3ogos4j9ar4id">Today</span>
            <span className="font-display text-5xl font-bold text-gold sm:text-6xl" data-id="element-240" data-mp="3ti49o1c9msw0">$27 USD</span>
            <p className="mt-2 px-4 text-xs text-white/65 sm:text-sm" data-id="element-241" data-mp="7hq8destoro1">
              Get all 6 core volumes + 5 professional teacher bonuses for one payment of $27 USD.
            </p>
          </div>
        </div>
        <div className="mt-6 sm:mt-8" data-id="element-242" data-mp="3tpg26rk5y8hf">
          <div className="mb-8 flex flex-col items-center text-center" data-id="element-243" data-mp="3pm9zftw9ezfp">
            <span className="text-xs font-bold uppercase tracking-widest text-gold" data-id="element-244" data-mp="3po4mpev073my">
              Take a look inside
            </span>
            <h3 className="mt-2 font-display text-2xl font-bold leading-tight text-white sm:text-3xl" data-id="element-245" data-mp="l7a4w2vt8sow">
              Inside <span className="text-gold" data-id="element-246" data-mp="gfs5vkdcl26k">THE COMPLETE ART YEAR™</span>
            </h3>
            <p className="mt-4 text-base font-bold text-white sm:text-lg" data-id="element-247" data-mp="cg1jdsuut87u">
              6 Core Volumes + 5 Professional Teacher Bonuses
            </p>
            <p className="mt-1 text-sm text-white" data-id="element-248" data-mp="18z8w5wbnmyno">
              See the lessons, visual references, projects, planning tools and assessment resources
              included inside the system.
            </p>
            <div className="mt-6 w-full overflow-hidden rounded-xl border-2 border-gold bg-navy" data-id="element-249" data-mp="oqr3g4uqksz3">
              <div className="relative aspect-square w-full" data-id="element-250" data-mp="tl4ww1pu8q14">
                <img src="https://cdn.magicpatterns.com/patterns/generated-images/bc39cdf3-b0f9-4902-bb8a-2f799b6527a8.jpg" alt="Preview of interior pages from THE COMPLETE ART YEAR: Elements of Art reference, shading and perspective technique pages, color relationships, composition comparisons, an art-analysis page, project planning, an assessment rubric, the 36-week planning roadmap, quick-activity cards, a classroom poster and a student portfolio reflection page" loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-251" data-mp="fpau80fnqwwg" />
              </div>
            </div>
            <p className="mt-3 text-xs text-white/70" data-id="element-252" data-mp="1v5i9so2mp60i">
              One-Time Payment · No Subscription · Instant Digital Access · Lifetime Access
            </p>
          </div>
          <CTAButton label="GET THE COMPLETE ART YEAR™" href={CHECKOUT_URL} data-id="element-253" data-mp="3awc53ob0vxbq" />
          <TodayOfferCard data-id="element-254" data-mp="3pkp46u5epwag" />
        </div>
      </motion.div>
    </section>;
}